<!--Adding Comment-->
    <div class="form-group" *ngIf="comment" >
        <input style="width: 90%; height: 40px; margin-left: 0px;" type="text" class="form-control" placeholder="Comment" [(ngModel)]="comment.description" required #description="ngModel"/>
        <a href="/home/clubsdata/details">
          <button   routerLink="/home/clubsdata/details" class="btn btn-primary" style="height: 40px; margin-left: -20%;" (click)="addComment(comment)" [disabled]="description.invalid"> Add Comment </button>
        </a>
      </div>
      <!--Rating Comments-->
<div class="main-card"  *ngFor="let com of commentaire">
    <div class="cards">
      <div class="card">
        <div class="content">
          <li style="list-style-type: none; float: left; margin-left: -85%; margin-top: -20px;">
            <img class="comPic" src="http://localhost:9091/User/{{ com.user.profileImage }}" style="width: 60px; height: 60px; border-radius: 50%; border: 2px solid #5a54ff; display: inline;" alt="profile Image"/>
            <a class="nav-link" style="font-weight: bold; display: inline; color: black; margin-left: 0px; margin-bottom: 10px;">
              <i class="ion-md-power"></i> &nbsp; {{com.user.nom}} {{com.user.prenom}} <br><small class="pub" style="margin-left: 125px;display: block;transform: translateY(-26px);">Published on : {{com.date}}</small>
            </a>
            <br>
          </li>
            <p style="margin-left: 8%; margin-right:8% ; margin-top: 10px; color: black; text-align: justify;" >{{com.description}}</p>
            <br>
            <!--<p style="margin-left: -100px; color: #5a54ff;" (click)="getReponseByCommentaireId(com._id)">Show Respons</p>-->
        </div>
        <a href="/home/clubsdata/details" (click)="deleteCommentaire(com._id)" [hidden]="hideSupp(com.user._id)"><fa-icon [icon]="faTrash"  class="material-icons" style="display: flex;float: right; transform: translateY(-900%);margin-right: 30px;"></fa-icon></a>
  
      </div>
    </div>
  </div>